import {Injectable} from '@angular/core';
import {GaAction, GoogleAnalyticsService} from 'ngx-google-analytics';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {

    lang = 'ru';
    prefix = '';

    constructor(
        private translate: TranslateService,
        protected gaService: GoogleAnalyticsService
    ) {
        this.setCurrentLang(translate.currentLang);

        translate.onLangChange.subscribe((data) => {
            this.setCurrentLang(data.lang);
        });
    }

    trackView(path?: string, title?: string) {
        this.gaService.pageView(this.prefix + path, title);
    }

    trackEvent(action: GaAction | string, category?: string, label?: string, value?: number) {
        this.gaService.event(action, category, label, value);
    }

    setCurrentLang(lang) {
        this.lang = lang;
        this.prefix = lang === 'en' ? '/en' : '';
    }
}
